import { useFormikContext } from "formik";
import { UpdateSupplierOfficeInput } from "@/gql/graphql";
import { SwitchInput } from "@/lib/Components/Form/Inputs/SwitchInput";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";

export function OfficeNotificationForm() {
  const { values } = useFormikContext<UpdateSupplierOfficeInput>();
  return (
    <>
      <SwitchInput
        name="cc_booking_to_departure_office"
        label="Email office on booking"
        className="col-span-3"
        tooltip="Email the office when a booking is made departing the office."
      />
      {values.cc_booking_to_departure_office ? (
        <TextInput
          name="booking_email"
          label="Reservation email"
          className="col-span-4"
        />
      ) : null}
    </>
  );
}
